import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
//import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
//import PageContact from "containers/PageContact/PageContact";
//import PageAbout from "containers/PageAbout/PageAbout";
//import BlogPage from "containers/BlogPage/BlogPage";
import EpisodeOne from "containers/BlogPage/EpisodeOne";
import SiteHeader from "containers/SiteHeader";
import PageHome2 from "containers/PageHome/PageHome2";
import EpisodeTwo from "containers/BlogPage/EpisodeTwo";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome2 },
  { path: "/#", exact: true, component: PageHome2 },
  // Uncomment to work on the experiments
  //{ path: "/experiment", exact: true, component: PageHome },
  //
  //{ path: "/home-header-2", exact: true, component: PageHome },
  //
  //{ path: "/blog", component: BlogPage },
  { path: "/episode-one", component: EpisodeOne },
  { path: "/episode-two", component: EpisodeTwo },
  
  //
  //{ path: "/contact", component: PageContact },
  //{ path: "/about", component: PageAbout },
];

const Routes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />
      <Switch>
        {pages.map(({ component, path, exact }) => {
          return (
            <Route
              key={path}
              component={component}
              exact={!!exact}
              path={path}
            />
          );
        })}
        <Route component={Page404} />
      </Switch>
      <Footer />
    </BrowserRouter>
  );
};

export default Routes;
